<style scoped>
#app {
  width: 100%;
  height: 100vh;
  /* background-image: url("../assets/login-bg.png"); */
  /* background-size: cover; */
}
.logo {
  width: 100%;
}
.logo2 {
  width: 100px;
  height: 100px;
  margin: 0 auto;
}
.logo_image {
  width: 175px;
  height: 54px;
  margin: 47px 0px 0px 53px;
}
.logo_image2 {
  width: 100px;
  height: 100px;
}
.logo-form {
  width: 408px;
  height: 800px;
  /* background-color: red; */
  margin: 0 auto;
  text-align: center;
}
.logo-form-title {
  font-family: PingFang SC;
  font-size: 24px;
  font-weight: 500;
  line-height: 45px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #3d3d3d;
  margin: 16px 0px 24px 0px;
}
::v-deep .el-input__inner {
  height: 54px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #dfdfdf;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding-left: 40px;
}
::v-deep .el-input__inner::placeholder {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding-left: 16px;
}
.person_logo {
  width: 24px;
  height: 24px;
  margin: 16px 16px 0px 8px;
}
.verification_img {
  width: 127px;
  height: 46px;
  margin-top: 4px;
}
.df1 {
  display: flex;
  justify-content: end;
}
.mt16 {
  margin-top: 16px;
}
::v-deep .el-button {
  width: 100%;
  border-radius: 35px;
  background: #2e7516;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #ffffff;
  margin-top: 18px;
}

.read {
  text-align: center;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding: 16px 0px 34px 0px;
}
::v-deep .el-checkbox__inner {
  border-radius: 50%;
  margin: 0px 8px;
}
.login-line {
  display: flex;
}
.line1 {
  width: 161px;
  height: 0px;
  border-top: 1px solid #d8d8d8;
}
.line2 {
  flex: 1;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  margin-top: -8px;
}
.dialog-footer-button {
  width: 76px;
  height: 32px;
  border-radius: 2px;
  color: rgba(0, 0, 0, 0.85);
  background: #ffffff;
  line-height: 5px;
  font-size: 14px;
}
.dialog-footer-button2 {
  width: 76px;
  height: 32px;
  border-radius: 2px;
  color: #ffffff;
  background: #2e7516;
  line-height: 5px;
  font-size: 14px;
}

.header h1 {
  width: 100%;
  text-align: center;
  font-size: 24px;
}
.content {
  padding: 0px 20px 20px 20px;
}
.pt8 {
  padding-top: 8px;
}

.fw700 {
  font-weight: 700;
}
.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #0888ff;
  margin-top: 8px;
}
ul {
  margin-left: 40px;
}
.p16 {
    padding: 16px 0px;
}
</style>
<template>
  <div class="app">
    <div class="header">
      <h1>XRION 用户协议</h1>
    </div>
    <div class="content">
      <p class="pt8 fw700">发布日期：2025年08月01日</p>
      <p class="pt8 fw700">生效日期：2025年08月01日</p>

      <div class="fw700 pt8">
        <div class="p16">欢迎使用XRION！</div>
        <div>
          在开始使用XRION（以下简称“本服务”）提供的文本翻译、语音翻译、文档翻译等服务之前，请您仔细阅读并充分理解本《用户协议》（以下简称“本协议”）。您对本服务的任何访问或使用行为，即视为您已阅读、理解并同意接受本协议的全部条款约束。如您不同意本协议的任何内容，请立即停止使用本服务。
        </div>
      </div>

      <div class="section-title">一、 服务说明</div>
      <p>1.1 XRION服务范围</p>
      <p>XRION为用户提供以下核心功能：</p>
      <ul>
        <li>文本翻译：支持100+种语言的实时文字互译；</li>
        <li>语音翻译：通过麦克风或音频文件输入，实现语音实时翻译；</li>
        <li>
          文档翻译：支持PDF、DOCX、PPT等格式文件的全文翻译，并保留原始排版。
        </li>
      </ul>
      <p>1.2 服务限制</p>
      <ul>
        <li>
          您理解并同意，XRION的翻译结果基于人工智能技术生成，可能存在误差，不保证100%准确；
        </li>
        <li>本服务不适用于法律、医疗等专业领域的高精度翻译需求；</li>
        <li>
          禁止利用本服务从事任何违法、侵权或干扰系统正常运行的行为（如恶意爬取、自动化滥用等）。
        </li>
      </ul>

      <div class="section-title">二、用户账户</div>
      <p>2.1 注册与登录</p>
      <ul>
        <li>您可通过手机号、邮箱注册XRION账户；</li>
        <li>您需确保提供的注册信息真实、准确，并自行保管账户密码及验证码。</li>
      </ul>
      <p>2.2 账户安全</p>
      <ul>
        <li>如发现账户被盗用或异常登录，请立即联系客服（admin@xrion.ai）；</li>
        <li>XRION不因用户自身原因（如密码泄露）导致的损失承担责任。</li>
      </ul>

      <div class="section-title">三、使用规范</div>
      <p>3.1 禁止行为</p>
      <p>您承诺不得利用XRION服务从事以下行为：</p>
      <ul>
        <li>上传或传播违法、侵权、淫秽、暴力等内容；</li>
        <li>未经授权批量调用API或使用自动化工具（如爬虫）获取数据；</li>
        <li>干扰服务正常运行（如DDoS攻击、恶意刷量）。</li>
      </ul>
      <p>3.2 内容责任</p>
      <ul>
        <li>您需对上传的文本、语音或文档内容负责，确保其不侵犯第三方权利；</li>
        <li>XRION有权删除违规内容并暂停或终止违规用户的服务权限。</li>
      </ul>

      <div class="section-title">四、 知识产权</div>
      <p>4.1 XRION的权利</p>
      <ul>
        <li>本服务的软件、算法、界面设计等知识产权归XRION所有；</li>
        <li>您仅获有限、非排他性的使用权，不得反向工程或商业转售。</li>
      </ul>
      <p>4.2 用户内容权利</p>
      <ul>
        <li>您保留上传的原文及翻译结果的著作权；</li>
        <li>您授权XRION在匿名化、去标识化后使用相关数据优化翻译模型。</li>
      </ul>

      <div class="section-title">五、免责声明</div>
      <p>5.1 服务可用性</p>
      <p>XRION将尽力保障服务稳定，但不对以下情况负责：</p>
      <ul>
        <li>因不可抗力（如自然灾害、网络攻击）导致的服务中断；</li>
        <li>第三方服务（如支付、登录接口）引发的故障。</li>
      </ul>
      <p>5.2 翻译准确性</p>
      <ul>
        <li>翻译结果仅供参考，XRION不保证其绝对准确，不承担因依赖翻译内容导致的直接或间接损失。</li>
      </ul>

      <div class="section-title">六、协议修改与终止</div>
      <p>6.1 协议更新</p>
      <p>XRION可能根据业务或法律要求修订本协议，并通过官网或应用内公告通知。若您继续使用服务，即视为接受修订内容。</p>
      <p>6.2 账户注销</p>
      <p>您可随时通过【设置-账户管理-注销】申请关闭账户，XRION将在15个工作日内删除您的个人信息（法律要求保留的除外）。</p>
      
      <div class="section-title">七、 法律适用与争议解决</div>
      <p>7.1 本协议适用中华人民共和国法律。</p>
      <p>7.2 争议应优先通过友好协商解决；协商不成，提交XRION所在地有管辖权的人民法院诉讼。</p>

      <p>联系客服邮箱：<a href="">admin@xrion.ai </a></p>
      <p class="fw700 p16">再次提醒：使用XRION服务即代表您已阅读、理解并同意本协议的全部条款。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserAgreement",
  data() {
    return {
      dialogVisible: true,
    };
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {},
};
</script>
